// Per-browser panel state: whether the sidebar is open and which conversation
// it shows. Storage can be missing or throw (private mode, blocked site
// data); every failure falls back to a closed panel with a new conversation.

export const ASSISTANT_OPEN_KEY = 'autoclipper:ai-assistant:open';
export const ASSISTANT_CONVERSATION_KEY = 'autoclipper:ai-assistant:conversation';

const CONVERSATION_ID = /^[A-Za-z0-9_-]{1,128}$/;

type ReadableStorage = Pick<Storage, 'getItem'> | null | undefined;
type WritableStorage = Pick<Storage, 'setItem' | 'removeItem'> | null | undefined;

export interface AssistantPreferences {
  open: boolean;
  conversationId: string | null;
}

export function readAssistantPreferences(storage: ReadableStorage): AssistantPreferences {
  try {
    const open = storage?.getItem(ASSISTANT_OPEN_KEY) === '1';
    const stored = storage?.getItem(ASSISTANT_CONVERSATION_KEY) ?? null;
    return {
      open,
      conversationId: stored && CONVERSATION_ID.test(stored) ? stored : null,
    };
  } catch {
    return { open: false, conversationId: null };
  }
}

export function writeAssistantOpen(storage: WritableStorage, open: boolean): void {
  try {
    if (open) storage?.setItem(ASSISTANT_OPEN_KEY, '1');
    else storage?.removeItem(ASSISTANT_OPEN_KEY);
  } catch {
    // Remembering the panel is a convenience; ignore storage failures.
  }
}

export function writeAssistantConversation(storage: WritableStorage, conversationId: string | null): void {
  try {
    if (conversationId && CONVERSATION_ID.test(conversationId)) {
      storage?.setItem(ASSISTANT_CONVERSATION_KEY, conversationId);
    } else {
      storage?.removeItem(ASSISTANT_CONVERSATION_KEY);
    }
  } catch {
    // Same as above.
  }
}
